import { all } from 'redux-saga/effects/';

// global store
import appBannersSaga from 'src/store/appBanners/sagas';
import appBannersSagaWatcher from 'src/store/appBannerStats/saga';
import cashbackSaga from 'src/store/cashback/saga';
import client from '../../../store/client/sagas';
import payment from '../../../store/payment/sagas';
import globalView from '../../../store/view/sagas';
import globalAnalytics from '../../../store/analytics/sagas';
import wishlist from '../../../store/wishlist/sagas';

import certificate from './certificate';
import view from './view';
import analytics from './analytics';

function* sagas() {
  yield all([
    client(),
    payment(),
    globalView(),
    globalAnalytics(),
    wishlist(),
    appBannersSaga(),
    //
    certificate(),
    view(),
    analytics(),
    appBannersSagaWatcher(),
    cashbackSaga(),
  ]);
}

export default sagas;
